import React from 'react';

/**
 * Panel fejléccel — a jóváhagyott sablon `.panel`-je (2026-10-04).
 *
 * A fejléc egy vékony vonallal elválasztott sáv: balra a cím (15 px, félkövér) és
 * alatta opcionálisan egy rövid alcím, jobbra a gombok. Két változat:
 *   - alap: a törzs 20 px-es belső margóval
 *   - `flush`: a törzs végigér (listákhoz, táblázatokhoz)
 *
 * Az `icon` prop a régi hívások miatt megmaradt, de a panelfejléc nem rajzol ikont.
 */
export default function PanelCard({
  title,
  subtitle,
  actions,
  flush = false,
  className = '',
  bodyClassName = '',
  children,
}) {
  return (
    <div className={`card overflow-hidden ${className}`}>
      {(title || actions) && (
        /* A fejléc TÖRHET: ha a cím és a gombok nem férnek egy sorba, a gombok a
           cím alá kerülnek — keskeny kijelzőn sem tolódnak a képernyőn kívülre. */
        <div className="min-h-[52px] px-5 py-3 flex flex-wrap items-center justify-between gap-x-4 gap-y-2
                        border-b border-line-faint">
          <div className="min-w-0 flex-1 basis-60">
            {title && <h3 className="text-[15px] font-semibold text-gray-50">{title}</h3>}
            {subtitle && <p className="mt-0.5 text-[13px] text-gray-500">{subtitle}</p>}
          </div>
          {actions && <div className="min-w-0 max-w-full">{actions}</div>}
        </div>
      )}
      <div className={`${flush ? '' : 'p-5'} ${bodyClassName}`}>{children}</div>
    </div>
  );
}

/** Üres állapot: ikon-csempe + rövid mondat, listák helyére (a sablon `.empty`-je). */
export function EmptyState({ icon, title, hint, className = '' }) {
  return (
    <div className={`px-5 py-11 flex flex-col items-center gap-2.5 text-center ${className}`}>
      {icon && (
        <span className="w-11 h-11 rounded-xl grid place-items-center bg-gray-850 text-gray-500
                         shadow-[inset_0_0_0_1px_rgba(255,255,255,0.10)]">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75"
               strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5" aria-hidden="true">
            {icon}
          </svg>
        </span>
      )}
      <p className="text-sm text-gray-100">{title}</p>
      {hint && <p className="-mt-1.5 text-[13px] text-gray-500">{hint}</p>}
    </div>
  );
}
